import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGINATION } from 'utils/constants';
import { getUnitIntegrationTaskListThunk } from 'components/pages/unit-integration/unit-integration.thunk';

const _paginateDefault: Pagination = {
    page: 1,
    per_page: PAGINATION.LIMIT_PER_PAGE,
    total: 0,
    total_pages: 0,
};

const initialState: IUnitIntegrationState = {
    dataTable: [],
    paginateMetaData: _paginateDefault,
    formSearch: undefined,
    getKeywords: [],
};

const unitIntegrationSlice = createSlice({
    name: 'unitIntegration',
    initialState,
    reducers: {
        setDataTable: (state: IUnitIntegrationState, action: PayloadAction<IUnitIntegrationTask[]>) => {
            state.dataTable = action.payload;
        },
        setPaginateMetaData: (state: IUnitIntegrationState, action: PayloadAction<Pagination>) => {
            state.paginateMetaData = action.payload;
        },
        setSort: (
            state: IUnitIntegrationState,
            action: PayloadAction<{ ascending: boolean; fieldName: string; sortColumn: number } | undefined>,
        ) => {
            state.sort = action.payload;
        },
        setFormSearch: (
            state: IUnitIntegrationState,
            action: PayloadAction<IUnitIntegrationTaskSearch | undefined>,
        ) => {
            state.formSearch = action.payload;
        },
        setKeywords: (state: IUnitIntegrationState, action: PayloadAction<string[]>) => {
            state.getKeywords = action.payload;
        },
        resetUnitIntegrationState: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(getUnitIntegrationTaskListThunk.fulfilled, (state, action) => {
            state.dataTable = action.payload?.data ?? [];
            state.paginateMetaData = action.payload?.pagination ?? _paginateDefault;
        });
    },
});

export const {
    setDataTable,
    setPaginateMetaData,
    setSort,
    setFormSearch,
    setKeywords,
    resetUnitIntegrationState,
} = unitIntegrationSlice.actions;

export default unitIntegrationSlice.reducer;
